import { LogService } from '@absg/angular-common';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, timer } from 'rxjs';
import { catchError, concatMap, map, retryWhen } from 'rxjs/operators';

@Injectable()
export class RetryInterceptor implements HttpInterceptor {
  constructor(private loggingService: LogService) { }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        retryWhen(errors => errors.pipe(
          concatMap((httpResult: HttpErrorResponse, retryAttemptNumber: number) => {
            if (
              retryAttemptNumber < 2 // retries less than 2
              && (
                httpResult.status === 0 // APIM connection issues sometimes come back as 0
                || httpResult.status === 400 // APIM connection issues sometimes come back as 400 with PUT/POST
                || (httpResult.status >= 500 && httpResult.status < 600) // any 500 we'll retry
              )
            ) {
              const timeDelay = retryAttemptNumber === 0 ? 750 : 2500;
              return timer(timeDelay).pipe(map(() => httpResult));
            }
            return throwError(httpResult);
          }),
        )),
        catchError(err => {
          this.loggingService.logError(err);
          return throwError(err);
        }),
      );
  }
}
